import deDE from 'antd-v6/locale/de_DE';
import enGB from 'antd-v6/locale/en_GB';
import enUS from 'antd-v6/locale/en_US';
import esES from 'antd-v6/locale/es_ES';
import huHU from 'antd-v6/locale/hu_HU';
import itIT from 'antd-v6/locale/it_IT';
import ptBR from 'antd-v6/locale/pt_BR';
import ptPT from 'antd-v6/locale/pt_PT';
import trTR from 'antd-v6/locale/tr_TR';
import type { Language } from './SystemLanguageContext';

function getAntdLocale(locale: Language) {
  switch (locale) {
    case 'en-US':
      return enUS;
    case 'en-GB':
      return enGB;
    case 'es-AR':
    case 'es-ES':
      return esES;
    case 'pt-BR':
      return ptBR;
    case 'pt-PT':
      return ptPT;
    case 'it-IT':
      return itIT;
    case 'de-DE':
      return deDE;
    case 'hu-HU':
      return huHU;
    case 'tr-TR':
      return trTR;
    default:
      return enUS;
  }
}

export { getAntdLocale };
